// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_DogLiabilityV1LukoToGetsafeDe = z.object({
  pet_name: z.string().min(1).optional(),
  breed_type: z.string().min(1),
  pet_gender: z.enum(['male', 'female']).optional(),
  pet_born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  tariff_line: z.enum(['comfort']),
  bite_coverage: z.boolean(),
  breed_category: z.enum(['standard', 'high']),
  sleep_well_coverage: z.boolean(),
  contract_holder_born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  rented_property_coverage: z.boolean(),
  number_of_claims_in_last_3y: z.enum(['0-2', '3+']).optional(),
  cancelled_by_previous_insurer: z.boolean().optional(),
})

const Schema_DogLiabilityV1LukoToGetsafeDe = BaseSchema_DogLiabilityV1LukoToGetsafeDe

export default Schema_DogLiabilityV1LukoToGetsafeDe
